let lastRoute: string = "/"

export function recordRoute(path: string) {
  lastRoute = path
  try {
    sessionStorage.setItem("lastRoute", path)
  } catch (e) {
    console.error("Failed to persist last route:", e)
  }
}

export function getLastRoute() {
  try {
    return sessionStorage.getItem("lastRoute") || lastRoute || "/"
  } catch {
    return lastRoute || "/"
  }
}
